import {
  IUserData,
  IUserDetailsData,
  IUser,
} from "../../common/interfaces/user.interface";
import { IChangeWhitelistingStatus } from "../../common/interfaces/whitelisting.interface";
import { get, patch, post } from "../utilities/http";
import {
  BULK_CHANGE_STATUS,
  CHANGE_STATUS,
  DASHBOARD_USERS,
  REFRESH_DISCORD_USERNAME,
  USERS,
  USER_MEMBERSHIPS,
} from "../utilities/urls";

export function getUsers(): Promise<IUserData[]> {
  return get(DASHBOARD_USERS);
}

export function getAllUserClubs(pubKey: string): Promise<IUserDetailsData> {
  return get(`${USER_MEMBERSHIPS}/${pubKey}`);
}

export function getUser(pubKey: string): Promise<IUser> {
  return get(`${USERS}/${pubKey}`);
}

export function changeWhitelistingRequestStatus(
  whitelistingDto: IChangeWhitelistingStatus
) {
  return patch(CHANGE_STATUS, whitelistingDto);
}

export function changeStatusBulk(userPubkeys: string[]) {
  return patch(BULK_CHANGE_STATUS, { userPubkeys: userPubkeys });
}

export function refreshDiscordUsername(snowflake: string | undefined) {
  if (snowflake) {
    return post(REFRESH_DISCORD_USERNAME, { snowflake: snowflake });
  }
}

export default {};
